// Значок «★ 5,0 · 24 rəy Google-da» — ссылка на профиль Yolutap в Google Картах
// в новой вкладке. Где стоит: /start (под заголовком и маленький у «Далее»),
// главная (заголовок блока «Ailələr nə deyir»). Число и рейтинг —
// src/lib/google-reviews.ts. Стили — .grb в src/styles.css.
import { trackGoogleReviewsClick } from "@/lib/analytics";
import { GOOGLE_REVIEWS, REVIEWS_BADGE_LABEL, reviewsBadgeText } from "@/lib/google-reviews";

export function GoogleReviewsBadge({
  lang,
  placement,
  size = "md",
}: {
  lang: "az" | "ru" | "en";
  /** Для GA: где нажали (start_head, start_cta, home_reviews). */
  placement: string;
  size?: "md" | "sm";
}) {
  const text = reviewsBadgeText(lang);
  return (
    <a
      className={`grb grb--${size}`}
      href={GOOGLE_REVIEWS.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${text}. ${REVIEWS_BADGE_LABEL[lang]}`}
      data-google-reviews={placement}
      onClick={() => trackGoogleReviewsClick({ placement, language: lang })}
    >
      <span className="grb__star" aria-hidden="true">
        ★
      </span>{" "}
      {text}
    </a>
  );
}
